<template>
    <div>
        <van-nav-bar
                title="我的站点列表"
                left-text="返回"
                right-text="创建站点"
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
        />

        <van-list
                v-model="loading"
                :finished="finished"
                @load="onLoad">
            <van-row v-for="(item,index) in list" :key="item.id" :index="index">
                    <van-panel :title="item.site_name" status="正常">
                        <!--<div class="site_url">站点网址：<a :href="siteUrl+item.user_id">{{siteUrl+item.user_id}}</a></div>-->
                        <div slot="footer" class="site_btn">
                            <van-button size="small" type="danger" @click="onClickPreview(item.id)">预览</van-button>
                            <van-button size="small" type="danger" @click="onClickEdit(item.id)" class="btn-shopedit">编辑</van-button>
                            <van-button size="small" type="danger" @click="onClickManage(item.id)" class="btn-shopedit">管理</van-button>
                          <van-button size="small" type="danger" @click="onClickDelete(item.id)" class="btn-shopedit">删除</van-button>
                        </div>
                    </van-panel>
            </van-row>
        </van-list>
    </div>
</template>

<script>
    import { NavBar,Row,Col,List,Panel,Button,Dialog } from 'vant';
    import Cookies from 'js-cookie'
    export default {
        name: "ShopIndex",
        components:{
            [NavBar.name]:NavBar,
            [Row.name]:Row,
            [Col.name]:Col,
            [List.name]:List,
            [Panel.name]:Panel,
            [Button.name]:Button
        },
        data(){
            return {
                list:[],
                finished:false,
                loading:false,
                storeId:0,
                siteUrl:'',
                userId:0
            }
        },
        created:function () {
            // var storeId = this.$cookies.set('storeId',1);
            // this.storeId = this.$cookies.get('storeId');
            //this.siteUrl = this.domainUrl+'/store/view?id=';
            this.userId = Cookies.get('user_id');
        },
        methods: {
            onClickLeft() {
                this.$router.push('/');
            },
            onClickRight() {
                this.$router.push('/mobile/site/create')
            },
            onLoad(){
                var _this = this;
                this.$http.get('/v1/sites/index',{params:{siteType:1,userId:this.userId}}).then(function (res) {
                    _this.list = res.data.siteList;
                });
                this.finished = true;
                this.loading = false;
            },
            onClickPreview(id){
                location.href = 'http://'+id+'.'+this.siteDomain;
            },
            onClickEdit(id){
                this.$router.push({path:'/mobile/site/edit',query:{id:id}});
            },
            onClickManage(id){
                this.$router.push('/mobile/index?siteId='+id);
            },
            onClickDelete(id){
                this.$http.delete('/v1/sites/delete',{params:{siteId:id}}).then(function (res) {
                    if(res.data.errcode == 0){
                        Dialog.alert({
                            message:'删除成功'
                        })

                        this.$http.get('/v1/sites/index',{params:{siteType:1,userId:this.userId}}).then(function (res) {
                            this.list = res.data.siteList;
                        });
                    }else{
                        this.$message.error(res.data.msg)
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .site_url{
        margin: 10px 0 10px 10px;
        font-size: 12px;
    }
    .site_btn{
        text-align: right;
    }
    .btn-shopedit{
        margin:0 0 0 10px;
    }
</style>
